(function () {
  'use strict';
  const configNode = document.getElementById('paw-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const text = config.strings;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || (config.root.replace(/\/?$/, '/'));
  const cartDialog = document.getElementById('cart-dialog');
  const imageDialog = document.getElementById('image-dialog');
  let activeGallery = null;
  let mutationPending = false;
  const money = cents => new Intl.NumberFormat(config.locale, { style: 'currency', currency: config.currency }).format(Number(cents) / 100);
  const node = (tag, className, content) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (content !== undefined) element.textContent = content;
    return element;
  };
  const status = message => { document.getElementById('live-status').textContent = message; };
  async function request(path, data) {
    const response = await fetch(root + path, {
      method: data ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', ...(data ? { 'Content-Type': 'application/json' } : {}) },
      ...(data ? { body: JSON.stringify(data) } : {})
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || text.error);
    return result;
  }
  function openDialog(dialog) {
    if (dialog && typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
  }
  function updateCount(cart) {
    document.querySelectorAll('.cart-count').forEach(badge => {
      badge.textContent = cart.item_count;
      badge.hidden = cart.item_count === 0;
    });
    document.getElementById('cart-title-count').textContent = '(' + cart.item_count + ')';
    if (cart.currency) config.currency = cart.currency;
  }
  function renderCart(cart) {
    updateCount(cart);
    const content = document.getElementById('cart-content');
    content.replaceChildren();
    if (!cart.items.length) {
      const empty = node('div', 'empty-cart');
      empty.append(node('h3', '', text.cart_empty));
      const keep = node('button', 'primary', text.continue);
      keep.type = 'button';
      keep.addEventListener('click', () => cartDialog.close());
      empty.append(keep); content.append(empty); return;
    }
    cart.items.forEach(item => {
      const row = node('div', 'cart-item');
      if (item.image) {
        const img = node('img'); img.src = item.image; img.alt = item.product_title;
        img.width = 92; img.height = 92; row.append(img);
      }
      const info = node('div', 'cart-item-info');
      const link = node('a', '', item.product_title); link.href = item.url; info.append(link);
      if (item.variant_title) info.append(node('small', '', item.variant_title));
      if (item.selling_plan_allocation) info.append(node('small', '', item.selling_plan_allocation.selling_plan.name));
      Object.entries(item.properties || {}).forEach(([name, value]) => {
        if (!name.startsWith('_') && value) info.append(node('small', '', name + ': ' + value));
      });
      (item.line_level_discount_allocations || []).forEach(discount => info.append(node('small', '', discount.discount_application.title + ' (−' + money(discount.amount) + ')')));
      const controls = node('div', 'cart-line-actions');
      const quantity = node('div', 'quantity-controls');
      const less = node('button', '', '−'); less.type = 'button'; less.setAttribute('aria-label', text.quantity + ' − ' + item.product_title);
      const number = node('span', '', item.quantity);
      const more = node('button', '', '+'); more.type = 'button'; more.setAttribute('aria-label', text.quantity + ' + ' + item.product_title);
      less.addEventListener('click', () => changeItem(item.key, item.quantity - 1));
      more.addEventListener('click', () => changeItem(item.key, item.quantity + 1));
      quantity.append(less, number, more);
      const remove = node('button', 'remove-item', text.remove); remove.type = 'button';
      remove.addEventListener('click', () => changeItem(item.key, 0));
      controls.append(quantity, remove); info.append(controls);
      row.append(info, node('strong', '', money(item.final_line_price)));
      content.append(row);
    });
    (cart.cart_level_discount_applications || []).forEach(discount => {
      const line = node('div', 'cart-row'); line.append(node('span', '', discount.title), node('span', '', '−' + money(discount.total_allocated_amount))); content.append(line);
    });
    const total = node('div', 'cart-row total'); total.append(node('span', '', text.subtotal), node('strong', '', money(cart.total_price))); content.append(total);
    content.append(node('p', 'cart-note', text.cart_note));
    const form = node('form'); form.action = config.cart; form.method = 'post';
    const checkout = node('button', 'primary', text.checkout); checkout.type = 'submit'; checkout.name = 'checkout';
    form.append(checkout); content.append(form);
    const view = node('a', 'footer-link', text.view_cart); view.href = config.cart; content.append(view);
  }
  async function showCart() {
    const cart = await request('cart.js');
    renderCart(cart);
    cartDialog.querySelector('.cart-error').textContent = '';
    openDialog(cartDialog);
  }
  async function changeItem(key, quantity) {
    if (mutationPending) return;
    mutationPending = true;
    const error = cartDialog.querySelector('.cart-error'); error.textContent = '';
    const content = document.getElementById('cart-content'); content.setAttribute('aria-busy', 'true');
    content.querySelectorAll('button').forEach(button => { button.disabled = true; });
    try {
      const cart = await request('cart/change.js', { id: key, quantity });
      renderCart(cart);
      if (document.getElementById('CartForm')) window.location.reload();
    } catch (err) { error.textContent = err.message || text.error; }
    finally {
      mutationPending = false; content.removeAttribute('aria-busy');
      content.querySelectorAll('button').forEach(button => { button.disabled = false; });
    }
  }
  document.addEventListener('click', event => {
    const close = event.target.closest('[data-close]');
    if (close) close.closest('dialog').close();
    const cartLink = event.target.closest('.cart-toggle');
    if (cartLink && typeof cartDialog.showModal === 'function') {
      event.preventDefault(); showCart().catch(() => { window.location.href = config.cart; });
    }
    if (event.target.closest('.search-toggle')) openDialog(document.getElementById('search-dialog'));
    const menu = event.target.closest('#menu-toggle');
    if (menu) {
      const nav = document.getElementById('mobile-nav');
      nav.hidden = !nav.hidden; menu.setAttribute('aria-expanded', String(!nav.hidden));
    }
  });
  document.querySelectorAll('dialog').forEach(dialog => {
    dialog.addEventListener('click', event => {
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }
    });
  });
  document.getElementById('lightbox-prev').addEventListener('click', () => activeGallery && activeGallery(-1));
  document.getElementById('lightbox-next').addEventListener('click', () => activeGallery && activeGallery(1));
  imageDialog.addEventListener('keydown', event => {
    if (event.key === 'ArrowLeft') { event.preventDefault(); if (activeGallery) activeGallery(-1); }
    if (event.key === 'ArrowRight') { event.preventDefault(); if (activeGallery) activeGallery(1); }
  });
  function setup(scope) {
    scope.querySelectorAll('[data-paw-product]').forEach(product => {
      if (product.dataset.initialized) return;
      product.dataset.initialized = 'true';
      const productConfig = JSON.parse(product.querySelector('[data-product-config]').textContent);
      productConfig.variants = Array.isArray(productConfig.variants) ? productConfig.variants : [];
      let variantId = productConfig.variantId;
      let pack = product.querySelector('[name="bundle"]:checked').value;
      const form = product.querySelector('[data-product-form]');
      const add = product.querySelector('[data-add-cart]');
      const error = product.querySelector('.product-error');
      const sticky = product.parentElement.querySelector('[data-sticky-buy]');
      let busy = false;
      const selectedExtras = () => Array.from(product.querySelectorAll('.bundle.selected [data-extra]:checked:not(:disabled)')).map(input => ({ id: Number(input.dataset.id), price: Number(input.dataset.price) }));
      const offer = () => window.PawCommerce.offerFor(productConfig, pack, variantId);
      const saveLabel = percent => text.save.replace('__PERCENT__', percent);
      const showMoney = (element, amount, show) => { element.textContent = money(amount); element.hidden = !show; };
      function refresh() {
        product.querySelectorAll('.bundle').forEach(card => {
          const cardOffer = window.PawCommerce.offerFor(productConfig, card.dataset.pack, variantId);
          const radio = card.querySelector('[name="bundle"]');
          const selected = String(card.dataset.pack) === String(pack);
          card.classList.toggle('selected', selected); radio.checked = selected;
          card.querySelector('[data-pack-price]').textContent = money(cardOffer.price);
          showMoney(card.querySelector('[data-pack-compare]'), cardOffer.compare, cardOffer.compare > cardOffer.price);
          const unit = window.PawCommerce.offerFor(productConfig, 1, variantId);
          const baseline = unit.price * Number(card.dataset.pack);
          const saved = baseline ? Math.round(100 * (baseline - cardOffer.price) / baseline) : 0;
          const saving = card.querySelector('[data-pack-saving]'); saving.hidden = saved <= 0; saving.textContent = saveLabel(saved);
        });
        const chosen = offer(); const single = window.PawCommerce.offerFor(productConfig, 1, variantId);
        product.querySelector('[data-unit-price]').textContent = money(single.price);
        showMoney(product.querySelector('[data-unit-compare]'), single.compare, single.compare > single.price);
        const sale = product.querySelector('[data-unit-save]'); sale.hidden = single.compare <= single.price;
        sale.textContent = saveLabel(single.compare ? Math.round(100 * (single.compare - single.price) / single.compare) : 0);
        const total = window.PawCommerce.selectedTotal(chosen, selectedExtras());
        product.querySelector('[data-bundle-total]').textContent = money(total);
        if (sticky) sticky.querySelector('[data-sticky-price]').textContent = money(total);
        add.disabled = busy || !chosen.available;
        add.textContent = busy ? text.adding : chosen.available ? text.add : chosen.id ? text.sold_out : text.unavailable;
      }
      form.addEventListener('change', event => {
        if (event.target.matches('[name="bundle"]')) pack = event.target.value;
        if (event.target.matches('[data-extra]')) pack = event.target.closest('.bundle').dataset.pack;
        if (event.target.matches('[data-variant]')) variantId = Number(event.target.value);
        error.hidden = true; refresh();
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy || !offer().available) return;
        busy = true; error.hidden = true; refresh();
        try {
          await request('cart/add.js', { items: window.PawCommerce.buildItems(offer(), selectedExtras()) });
          status(text.added);
          try { await showCart(); } catch (_) { window.location.href = config.cart; }
        } catch (err) {
          error.textContent = err.message || text.error; error.hidden = false;
        } finally { busy = false; refresh(); }
      });
      const thumbs = Array.from(product.querySelectorAll('.thumb'));
      const hero = product.querySelector('#hero-image');
      const large = document.getElementById('lightbox-image');
      let imageIndex = 0;
      function setImage(index) {
        imageIndex = (index + thumbs.length) % thumbs.length;
        const selected = thumbs[imageIndex];
        if (!selected) return;
        hero.removeAttribute('srcset'); hero.removeAttribute('sizes');
        hero.src = selected.dataset.image; hero.alt = selected.querySelector('img').alt;
        large.src = hero.src; large.alt = hero.alt;
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === imageIndex)));
      }
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => setImage(i)));
      product.querySelector('[data-gallery-prev]').addEventListener('click', () => setImage(imageIndex - 1));
      product.querySelector('[data-gallery-next]').addEventListener('click', () => setImage(imageIndex + 1));
      product.querySelector('.main-image').addEventListener('click', () => {
        large.src = hero.currentSrc || hero.src; large.alt = hero.alt;
        activeGallery = delta => setImage(imageIndex + delta); openDialog(imageDialog);
      });
      if (sticky && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          const entry = entries[0]; sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        }, { threshold: 0 });
        observer.observe(add);
        product._pawCleanup = () => observer.disconnect();
      }
      refresh();
    });
    scope.querySelectorAll('.comparison-slider').forEach(slider => {
      if (slider.dataset.initialized) return;
      slider.dataset.initialized = 'true';
      const range = slider.querySelector('input[type="range"]');
      range.addEventListener('input', () => {
        slider.querySelector('.after').style.clipPath = 'inset(0 0 0 ' + range.value + '%)';
        slider.querySelector('.compare-divider').style.left = range.value + '%';
      });
    });
  }
  setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-paw-product]').forEach(product => product._pawCleanup && product._pawCleanup()));
  window.addEventListener('pageshow', event => { if (event.persisted) request('cart.js').then(updateCount).catch(() => {}); });
})();
